import { render, staticRenderFns } from "./GerenciadorMarcasDespadronizadas.vue?vue&type=template&id=00ed113b&scoped=true"
import script from "./GerenciadorMarcasDespadronizadas.vue?vue&type=script&lang=js"
export * from "./GerenciadorMarcasDespadronizadas.vue?vue&type=script&lang=js"
import style0 from "./GerenciadorMarcasDespadronizadas.vue?vue&type=style&index=0&id=00ed113b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ed113b",
  null
  
)

export default component.exports